<template>
  <div class="page-template">
    <!--    支付接口-->
    <div class="page-title">{{ title }}</div>
    <div class="page-edit">
      <el-form :model="form" ref="form" class="setting-form" label-width="280px" :rules="rules" @submit.native.prevent>
        <el-col :span="24">
          <el-form-item prop="dbyPayMchnt" label="商户号">
            <el-input type="text" v-model.trim="form.dbyPayMchnt" placeholder="请输入渠道号" :disabled="isEdit"></el-input>
            <el-button @click="getMchnt" type="primary">校验</el-button>
            <el-button v-if="isEdit" @click="dbyMchntEdit" type="primary">编辑</el-button>
            <div v-if="mchntName">商户名称：{{ mchntName }}</div>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="aliPayAppid" label="支付宝Id">
            <el-input type="textarea" v-model.trim="form.aliPayAppid"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="aliPayPublicKey" label="支付宝公钥">
            <el-input type="textarea" v-model.trim="form.aliPayPublicKey"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="aliPayPrivateKey" label="支付宝私钥">
            <el-input type="textarea" v-model.trim="form.aliPayPrivateKey"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="wechatPayMchnt" label="微信商户号">
            <el-input type="textarea" v-model.trim="form.wechatPayMchnt"></el-input>
          </el-form-item>
        </el-col>
      </el-form>
      <div class="foot">
        <el-button type="primary" @click="save">提交</el-button>
        <!--        <el-button @click="reset">重置</el-button>-->
      </div>
    </div>

    <el-dialog title="商户号编辑" :visible.sync="showBox" :close-on-click-modal="false">
      <el-form :model="form" ref="form" class="setting-form" label-width="360px" :rules="rules"
               @submit.native.prevent>
        <el-col :span="24">
          <el-form-item prop="phone" label="手机号">
            <el-input type="input" v-model.trim="editForm.phone" :disabled="isEditPhone"></el-input>
            <el-button @click="sendVerifyCode" type="primary">获取验证码</el-button>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="phone" label="验证码">
            <el-input type="input" v-model.trim="editForm.verifyCode"></el-input>
          </el-form-item>
        </el-col>
        <el-col :span="24">
          <el-form-item prop="phone" label="新商户号">
            <el-input type="input" v-model.trim="editForm.newDbyPayMchnt"></el-input>
            <el-button @click="getUpdateMchnt" type="primary">校验</el-button>
            <div v-if="updateMchntName">商户名称：{{ updateMchntName }}</div>
          </el-form-item>
        </el-col>
      </el-form>
      <div class="foot">
        <el-button type="primary" @click="saveNewDbyPay">提交</el-button>
        <el-button @click="cancelSave">取消</el-button>
      </div>
    </el-dialog>
  </div>
</template>
<script>
  import api from "@/config/api";

  export default {
    data() {
      return {
        showBox: false,
        isEdit: false,
        isEditPhone: true,
        mchntName: '',
        updateMchntName: '',
        businessId: '',
        form: {
          dbyPayMchnt: '',// 商户号
          aliPayAppid: '',//支付宝Id
          aliPayPublicKey: '',//支付宝公钥
          aliPayPrivateKey: '',//支付宝私钥
          wechatPayMchnt: '',//'微信商户号'
        },
        editForm: {
          phone: '',
          verifyCode: '',
          newDbyPayMchnt: ''
        },
        title: '',
        rules: {},
      };
    },
    computed: {},
    created() {
      this.getDetail()
    },
    mounted() {
      this.title = document.title;
    },
    methods: {
      getDetail() {
        this.$axios.fetchGet(api.system.sysPayConfigGet, {}).then(res => {
          if (res.code === 200) {
            if (res.data) {
              this.form = res.data;
              this.businessId = res.data.id;
              if (this.form.dbyPayMchnt) {
                this.isEdit = true;
              }
            }
          } else {
            this.$message.error(res.errorMsg || '请求失败')
          }
        })
      },
      //更新校验
      getUpdateMchnt() {
        if (this.editForm.newDbyPayMchnt) {
          this.$axios.fetchGet('/api/eros/se/seMerchant/get/mchnt?dbyPayMchnt=' + this.editForm.newDbyPayMchnt, {}).then(res => {
            if (res.code === 200 && res.data) {
              this.updateMchntName = res.data
            } else {
              this.$message.error(res.errorMsg || '查询失败')
            }
          })
        } else {
          this.$message.warning('请输入要检验的商户号')
        }
      },
      // 检验
      getMchnt() {
        if (this.form.dbyPayMchnt) {
          this.$axios.fetchGet('/api/eros/se/seMerchant/get/mchnt?dbyPayMchnt=' + this.form.dbyPayMchnt, {}).then(res => {
            if (res.code === 200 && res.data) {
              this.mchntName = res.data
            } else {
              this.$message.error(res.errorMsg || '查询失败')
            }
          })
        } else {
          this.$message.warning('请输入要检验的商户号')
        }
      },
      save() {
        if (this.form.dbyPayMchnt) {
          this.$axios.fetchGet('/api/eros/se/seMerchant/get/mchnt?dbyPayMchnt=' + this.form.dbyPayMchnt, {}).then(res => {
            if (res.code === 200 && res.data) {
              this.mchntName = res.data
              this.$axios.fetchPost(api.system.sysPayConfig, this.form).then(res => {
                if (res.code === 200) {
                  this.$notify({
                    type: "success",
                    title: '保存操作',
                    message: '成功',
                    showClose: false,
                  });
                  // this.$message.success('保存成功')
                } else {
                  // this.$message.error(res.errorMsg || '保存失败')
                  this.$notify({
                    type: "error",
                    title: '保存操作',
                    message: '失败',
                    showClose: false,
                  });
                }
              })
            } else {
              this.$message.warning('请填写正确支付号')
            }
          })
        } else {
          this.$message.warning('请输入支付号')
        }
      },
      reset() {
        this.form = {
          dbyPayMchnt: '',// 商户号
          aliPayAppid: '',//支付宝Id
          aliPayPublicKey: '',//支付宝公钥
          aliPayPrivateKey: '',//支付宝私钥
          wechatPayMchnt: '',//'微信商户号'
        }
      },
      //编辑商户号
      dbyMchntEdit() {
        this.showBox = true;
        //获取商户商户号
        let merchantId = this.$utils.getSysUser().merchantId;
        this.$axios.fetchGet(api.system.submitMerchant + "?id=" + merchantId).then(data => {
          console.log(data);
          if (data.code === 200) {
            this.editForm.phone = data.data.phone;
          } else {
            this.$message.error("获取管理员手机号失败");
          }
        })
      },
      //保存编辑后的商户号
      saveNewDbyPay() {
        if (!this.editForm.verifyCode) {
          this.$message.warning("验证码为空");
          return false;
        }
        if (!this.editForm.newDbyPayMchnt) {
          this.$message.warning("商户号为空");
          return false;
        }
        if (!this.updateMchntName) {
          this.$message.warning("请校验商户号是否正确");
          return false;
        }
        let params = {};
        params.id = this.businessId;
        params.verifyCode = this.editForm.verifyCode;
        params.dbyPayMchnt = this.editForm.newDbyPayMchnt;
        params.phone = this.editForm.phone;
        this.$axios.fetchPost(api.system.updateDbyMchnt, params).then(data => {
          if (data.code === 200 && data.data === 'success') {
            this.$message.success("商户号更新成功");
            this.showBox = false;
            this.editForm.phone = '';
            this.editForm.verifyCode = '';
            this.editForm.newDbyPayMchnt = '';
            this.updateMchntName = '';
            this.getDetail();
          } else {
            if (data.errorMsg) {
              this.$message.error(data.errorMsg);
            } else {
              this.$message.error("商户号更新失败");
            }
          }
        });
      },
      //取消保存
      cancelSave() {
        this.showBox = false;
        this.editForm.phone = '';
        this.editForm.verifyCode = '';
        this.editForm.newDbyPayMchnt = '';
        this.updateMchntName = '';
      },
      sendVerifyCode() {
        if (!this.editForm.phone) {
          this.$message.error("手机号不能为空");
          return false;
        }
        this.$axios.fetchGet(api.system.updateDbyMchntsndSms + '?phone=' + this.editForm.phone).then(data => {
          if (data.code === 200) {
            this.$message.success("验证码发送成功")
          } else {
            this.$message.error("验证码发送失败")
          }
        })
      }
    }
  };
</script>
<style scoped>
  .page-title {
    margin-bottom: 10px;
  }

  >>> .el-textarea {
    width: 60%;
  }

  .foot {
    text-align: center;
  }

  >>> .el-form-item {
    margin-bottom: 10px;
  }
</style>




// WEBPACK FOOTER //
// src/page/system/pay/Interface.vue